import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";

export default function Modal({
  show,
  onClose,
  title,
  children,
  width = "500px",
  preventClose = false,
}) {
  return (
    <Transition.Root show={show} as={Fragment}>
      <Dialog
        as="div"
        className="z-[10000000000000000] fixed inset-0 overflow-y-auto"
        onClose={preventClose ? () => {} : onClose}
      >
        <div className="flex justify-center items-center sm:p-0 px-4 pt-4 pb-20 h-[100vh] text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="z-0 fixed bg-[#00000080] w-full h-screen" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:h-screen sm:align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              className="inline-block relative bg-[#292433] shadow-xl rounded-2xl overflow-hidden text-left sm:align-middle align-bottom transition-all transform"
              style={{ width: width, maxWidth: "90vw" }}
            >
              <div className="relative flex items-center my-[8px] max-h-[50px]">
                <div className="max-lg:top-[12px] right-[20px] absolute lg:">
                  <button
                    type="button"
                    className="rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-white hover:text-neutral-100"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon
                      className="w-[20px] h-[20px]"
                      aria-hidden="true"
                    />
                  </button>
                </div>
                {title && (
                  <div className="flex justify-center w-full h-full">
                    <div className="flex flex-col items-center w-full">
                      <div className="w-full text-center">
                        <h1 className="w-full text-white lg:text-[16px] max-lg:text-[14px] tracking-normal">
                          {title}
                        </h1>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <hr className="border-neutral-600/50" />

              <div className="space-y-[12px] px-[16px] py-[24px] text-[16px] text-neutral-700">
                {children}
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}